import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { styled } from "@mui/material";
import { useCropVarieties } from "stores";
import { Select } from "components";

const SelectorWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
});

const CropSelector = ({
  onChange,
  initialValues = {},
  isDisabled,
  className,
  classNames = {}, //selector
}) => {
  const { t } = useTranslation();

  const {
    cropVarieties,
    getAllTaxonomies,
    getCropsOfTaxonomy,
    getVarietiesOfCrop,
  } = useCropVarieties();

  const [taxonomyCode, setTaxonomyCode] = useState(initialValues.taxonomyId);
  const [cropCode, setCropCode] = useState(initialValues.cropId);
  const [varietyCode, setVarietyCode] = useState(initialValues.varietyId);
  const [dirtyFields, setDirtyFields] = useState({
    taxonomyCode: false,
    cropCode: false,
  });

  useEffect(() => {
    if (varietyCode && typeof onChange === "function") {
      onChange(varietyCode);
    }
  }, [varietyCode]);

  useEffect(() => {
    if (dirtyFields.taxonomyCode) {
      setCropCode(undefined);
    }
  }, [taxonomyCode]);

  useEffect(() => {
    if (dirtyFields.cropCode) {
      setVarietyCode(undefined);
    }
  }, [cropCode]);

  return cropVarieties.length ? (
    <SelectorWrapper className={clsx("crops-wrapper", className)}>
      <Select
        isDisabled={isDisabled}
        name="taxonomyId"
        options={getAllTaxonomies(true)}
        label={t("FieldsPage.AddFieldSidebar.Form.CropTaxonomy.Label")}
        onChange={(e) => {
          setDirtyFields((prev) => ({ ...prev, taxonomyCode: true }));
          setTaxonomyCode(e.target.value);
        }}
        classNames={{ select: classNames.selector }}
        value={taxonomyCode}
      />
      <Select
        isDisabled={isDisabled || !Boolean(taxonomyCode)}
        name="cropId"
        options={getCropsOfTaxonomy(taxonomyCode, true)}
        label={t("FieldsPage.AddFieldSidebar.Form.CropCrop.Label")}
        onChange={(e) => {
          setDirtyFields((prev) => ({ ...prev, cropCode: true }));
          setCropCode(e.target.value);
        }}
        value={cropCode}
        classNames={{ select: classNames.selector }}
      />
      <Select
        isDisabled={isDisabled || !Boolean(cropCode)}
        name="varietyId"
        options={getVarietiesOfCrop(cropCode)}
        label={t("FieldsPage.AddFieldSidebar.Form.CropVariety.Label")}
        onChange={(e) => setVarietyCode(e.target.value)}
        value={varietyCode}
        classNames={{ select: classNames.selector }}
      />
    </SelectorWrapper>
  ) : (
    <></>
  );
};

export default CropSelector;
